module.exports = __webpack_public_path__ + "static/itsm_capabilities_7-6b2f1fc4a0de1a3219a4b173f5f8bc1d.png";